<div class="container">
    <div class="row">
      <div class="error-icon col-auto">
        <i style="font-size: 150px" class="fas fa-user-shield"></i>
      </div>
      <div class="error-content col-md-6">
          <h1>Not Authorized</h1>
          <h2>Reason: Missing user personas.</h2>
          <br>
          <div class="error-details">
              If you believe you found this page in error, please submit a ticket or contact on-call support and ask to be assigned a proper Client Billing persona.
          </div>
      </div>
    </div>
</div>
